
import { UserDevice } from "@/models/user-device";
import { CompanyUserDeviceService } from "@/services/company-user-device-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			devices: [] as UserDevice[]
		};
	},
	props: {
		value: {
			type: Number,
		},
		companyId: {
			type: Number,
			required: true,
		},
		label: String,
		fancy: Boolean
	},
	computed: {
		deviceItems():ISelectItem<number>[] {
			let result:ISelectItem<number>[] = [{
				text: "Geen",
				value: 0
			}];

			result = result.concat(this.devices.map(d=>{
				return {
					text: d.name,
					value: d.id
				};
			}));
			return result;
		}
	},
	methods: {
		onInput(event:number){
			this.$emit("input", event);
		}
	},
	async mounted(){
		this.devices = await CompanyUserDeviceService.listDevices(this.companyId);
	}
});
